import { CountUp } from 'countup.js';

export default {
	init() {
		let counters = document.querySelectorAll('.js-animated-counter');
		let countUp = [];

		counters.forEach((counter, key) => {
			const options = {
			  duration: counter.dataset.duration,
			  useEasing: false,
			  useGrouping: false,
			};
			
			let value = counter.dataset.value;

			countUp[key] = new CountUp(counter, value, options);
			
		});

		window.onload = function () {
			countUp.forEach((counter) => {
				console.log(counter);
				counter.start();
			})
		}
	}
}